<template>
    <svg
        width="24px"
        height="24px"
        fill-rule="evenodd"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill-rule="evenodd"
            d="M12,3 C13.6568542,3 15,4.34314575 15,6 L15,9 L17,9 C18.1045695,9 19,9.8954305 19,11 L19,20 C19,20.5522847 18.5522847,21 18,21 L6,21 C5.44771525,21 5,20.5522847 5,20 L5,6 C5,4.34314575 6.34314575,3 8,3 L12,3 Z M12,5 L8,5 C7.44771525,5 7,5.44771525 7,6 L7,19 L13,19 L13,6 C13,5.44771525 12.5522847,5 12,5 Z M17,11 L15,10.999 L15,18.999 L17,19 L17,11 Z M11,11 C11.5522847,11 12,11.4477153 12,12 C12,12.5522847 11.5522847,13 11,13 L11,13 L9,13 C8.44771525,13 8,12.5522847 8,12 C8,11.4477153 8.44771525,11 9,11 L9,11 Z M9,7 L11,7 C11.5522847,7 12,7.44771525 12,8 C12,8.51283584 11.6139598,8.93550716 11.1166211,8.99327227 L11,9 L9,9 C8.44771525,9 8,8.55228475 8,8 C8,7.48716416 8.38604019,7.06449284 8.88337887,7.00672773 L9,7 L11,7 Z"
        />
    </svg>
</template>
